export default "__VITE_ASSET__BUVMDzIb__"